import { MinPasswordLength } from "../constants/main";


export const Translates: object = {
    ru: {
        mainProjectDescription: "Сервис для расчета токов замыкания в электрической сети на основе метода симметричных составляющих",
        forgotPasswordFormTitle: "Введите Ваш email для восстановления доступа",
        followInstructionsInEmail: "Следуйте инструкциям в этом письме.",

        errEmailIsBusyMsg: "Этот email уже присутствует в системе",
        errWrongCredentialsMsg: "Неправильный email или пароль",
        errPasswordsDontMatchMsg: "Пароли не совпадают",
        errPasswordsTooShortMsg: `Пароль слишком короткий. Минимальная длина ${MinPasswordLength} символов`,
        errServiceUnavailableMsg: "Сервис недоступен, попробуйте позже",
        cancel: "Отменить",
        finishSignUp: {
            finishRegistration: "Завершение регистрации",
            emailWasSend: "На Вашу почту {0} в течение нескольких минут придет письмо для активации аккаунта. Перейдите по ссылке в этом письме.",
            returnBackToLoginPage1: "После этого можно перейти на",
            returnBackToLoginPage2: "страницу входа",
        },
        _invites: {
            invite: "Пригласить",
            invites: "Приглашения",
            in_projects: "В проекты",
            in_organizations: "В организации",
            cancel: "Отменить",
            errorCancelInvites: "Не удалось отменить приглашение, попробуйте позже!",
            inviteNewUser: "Приглашение нового пользователя"
        },
        _organizations: {
            organization: "Организация",
            organizations: "Организации",
        },
        _projects: {
            personal: "Личный",
            shared: "Совместный",
        },
        _calc: {
            lastCalculation: "Последний расчёт",
        },
        _charts: {
            toggleLegend: "Переключить легенду",
            showV0: "Показать нулевую последовательность",
            hideV0: "Скрыть нулевую последовательность",
        },
        _resetPassword: {
            passwordChanged: "Ваш пароль успешно изменен!",
        },
        returnTo: "Теперь Вы можете вернуться на",
        toLoginPage: "страницу входа",
        goBack: "Вернуться",
        ago: "назад",
        updated: "Обновлен",
        main: "Основное",
        projects: "Проекты",
        docs: "Справочник",
        team: "Команда",
        users: "Пользователи",
        income: "Входящие",
        outcome: "Отправленные",
        save: "Сохранить",
        create: "Создать",
        settings: "Настройки",
        description: "Описание",
        sentInvites: "Отправленные приглашения",
        nodes: "Узлы",
        node: "Узел",
        equipments: "Оборудование",
        branches: "Ветви",
        mutualInductions: "Магнитосвязи",
        calculations: "Расчеты",
        name: "Название",
        nameLong: "Название элемента",
        accountName: "Имя аккаунта",
        tableRowLimit: "Ограничение по количеству строк",
        _tablesNodes:
        {
            nom: "ном",
            voltageClass: "Класс напряжения, кВ",
            load: "нагр",
            activePowerLoad: "Активная мощность нагрузки, МВт",
            reactivePowerLoad: "Реактивная мощность нагрузки, Мвар",
            externalGrid: "Внешняя сеть",
        },
        _tablesBranchesEquip:
        {
            r12Long: "Активное сопротивление прямой и обратной последовательности, Ом",
            x12Long: "Индуктивное сопротивление прямой и обратной последовательности, Ом",
            g12Long: "Активная проводимость на землю прямой и обратной последовательности, мкСм",
            b12Long: "Рективная проводимость на землю прямой и обратной последовательности, мкСм",
            r1Long: "Активное сопротивление прямой последовательности, Ом",
            x1Long: "Индуктивное сопротивление прямой последовательности, Ом",
            g1Long: "Активная проводимость на землю прямой последовательности, мкСм",
            b1Long: "Рективная проводимость на землю прямой последовательности, мкСм",
            r2Long: "Активное сопротивление обратной последовательности, Ом",
            x2Long: "Индуктивное сопротивление обратной последовательности, Ом",
            g2Long: "Активная проводимость на землю обратной последовательности, мкСм",
            b2Long: "Рективная проводимость на землю обратной последовательности, мкСм",
            r0Long: "Активное сопротивление обратной последовательности, Ом",
            x0Long: "Индуктивное сопротивление обратной последовательности, Ом",
            g0Long: "Активная проводимость на землю обратной последовательности, мкСм",
            b0Long: "Рективная проводимость на землю обратной последовательности, мкСм",            
            EMFModuleLong: "Модуль ЭДС генератора прямой последовательности",
            EMFAngleLong: "Угол ЭДС генератора прямой последоватлеьности",
            startNode: "Узел начала",
            startNodeLong: "Узел начала: название",
            endNode: "Узел конца",
            endNodeLong: "Узел конца: название",
            EMF: "ЭДС",
            angle: "угол",
            mod: "модуль",
            node: "Узел",
            nodeLong: "Узел к которому подключён элемент",
            startNodeGrounding: "Сост. ветви нулевой послед. со стор. узла начала",
            startNodeGroundingLong: "Сост. ветви нулевой послед. со стор. узла начала", 
            endNodeGrounding: "Сост. ветви нулевой послед. со стор. узла конца",            
            endNodeGroundingLong: "Сост. ветви нулевой послед. со стор. узла конца",   
            startNodenominalVoltage: "Vном узла начала",
            startNodenominalVoltageLong: "Напряжения узла начала для расчёта коэффициента трансформации, кВ. Сопротивления приведены к напряжению узла начала.",
            endNodenominalVoltage: "Vном узла конца",
            endNodenominalVoltageLong: "Напряжения узла конца для расчёта коэффициента трансформации, кВ. Сопротивления приведены к напряжению узла начала.",
            transformerAngle: "Угол коэф. транс.",
            transformerAngleLong: "Угол группы соединений обмоток трансформаора. Если неизвестен, то приравнять к нулю.",
        },
        _active:
        {
            isActiveLong: "Включенное состояние элемента в схеме замещения всех последовательностей",
            isActive: "Состояние",
            isActive0Long: "Включенное состояние элемента в схеме замещения нулевой последовательности",
            isActive0: "Состояние 0",
        },
        _profile: {
            profilePageHeader: "Профиль",
            profileLink: "Ваш профиль",
            deleteProfile: "Удалить профиль",
            deleteDialogText: "Удаление аккаунта нельзя отменить. Вы потеряете все данные без возможности восстановления! Все равно удалить?",
            successAccountDeletedMsg: "Ваш аккаунт удален.",
            loginIsTaken: "Этот логин уже занят, выберите другой",
        },
        filter: "Фильтр",
        actions: "Действия",
        addRecord: "Добавить строку",
        delete: "Удалить",
        duplicate: "Дублировать",
        logout: "Выйти",
        signIn: "Войти",
        signUp: "Зарегистрироваться",
        newPassword: "Новый пароль",
        continue: "Продолжить",
        forgotPassword: "Забыли пароль",
        password: "Пароль",
        repeatPassword: "Повторите пароль",
        alreadyHaveAccountSignIn: "Уже есть аккаунт? Войти",
        accept: "Принять",
        reject: "Отклонить",

        calculate: "Рассчитать",
        shortCircuitType: "Тип короткого замыкания",
        damageLocation: "Место повреждения",
        damageParams: "Параметры повреждения",
        measurementPlace: "Место замера",

        // Колонки таблиц
        zeroSequenceParameters: "Параметры нулевой последовательности",
        nonZeroSequenceParameters: "Параметры ненулевой последовательности",
        transformation_ratio: "Коэффициент трансформации",  //
        grounding: "Заземление нулевой последовательности",
        nominalVoltage: "Номинальное напряжение",

        // Единицы измеренний
        _measUnit:
        {
            kV: "кВ",
            kA: "кА",
            grad: "град.",
            MVA: "МВА",
            Om: "Ом",
            Mvar: "Mвар",
            MW: "MВт",
            mkSm: "мкСм",
        },

        // Типы КЗ
        _typeDamage:
        {
            K1Long: "K1 - Однофазное",
            K11Long: "K11 - Двухфазное на землю",
            K2Long: "K2 - Двухфазное",
            K3Long: "K3 - Трёхфазное",
        },     

        // Типы групп расчётных параметров
        vectorTypeEnum:
        {
            phase: "Фазные",
            linear: "Линейные",
            sequence: "Последовательности",
            sequencePhase: "Последовательности, фазные",
        },
        paramType: {
            currents: "Токи",
            voltages: "Напряжения",
            resistances: "Сопротивления",
            powers: "Мощности",
        },
        roleEnum: {
            owner: "Владелец",
            admin: "Администратор",
            member: "Участник",
        },
        grounded: "Заземлено",
        not_grounded: "Не заземлено",
        disabled: "Отключен",

        dropUnattachedRows: "Удалить непривязанные строки",

        contact: "Контакты",
        termsOfService: "Условия",
        aboutUs: "О нас",
        createProject: "Новый проект",
        newProject: "Новый проект",

        createdAt: "Дата создания",
        createFromTestBus: "Создать из тестовой схемы",
        // Отказ от ответственности
        _termsOfServicePage: {
            disclaimerOfWarranty: "Отказ от гарантии.",
            sentence1: "Этот продукт поставляется \"как есть\" без каких-либо гарантий, явных или подразумеваемых.",
            sentence2: "не делает никаких заявлений или гарантий относительно производительности, надежности или функциональности продукта.",
            sentence3: "Никто из авторов, участников, спонсоров, администраторов, операторов и лиц, как-либо ещё связанных с настоящим ресурсом, не несёт ответственность за появление неточной или ложной информации, а также за использование вами данных, содержащихся на этих веб-страницах либо найденных по ссылкам с них.",
        },
        generalSet: "Основные настройки",
        people: "Люди",
        dangerZone: "Опасная зона",
        noUsersFound: "Пользователь не найден",

        _electricElements: {
            inductor: "Индуктивность",
            capacity: "Ёмкость",
            resistor: "Резистор",
        },
    },
    en: {
        mainProjectDescription: "A service for calculating fault currents in an electrical network based on the symmetric component method",
        forgotPasswordFormTitle: "Enter your email to restore access to the account",
        followInstructionsInEmail: "Follow the instructions in this email.",

        errEmailIsBusyMsg: "This email is already registered",
        errWrongCredentialsMsg: "Incorrect email or password",
        errPasswordsDontMatchMsg: "Passwords don't match",
        errPasswordsTooShortMsg: `The password is too short. The minimum length is ${MinPasswordLength} characters`,
        errServiceUnavailableMsg: "The service is unavailable, please try again later",
        cancel: "Cancel",
        finishSignUp: {
            finishRegistration: "Finish registration",
            emailWasSend: "An email for account activation will be sent to your email {0} within a few minutes. Follow the link in this email.",
            returnBackToLoginPage1: "After that, you can move to",
            returnBackToLoginPage2: "login page",
        },
        _invites: {
            invite: "Invite",
            invites: "Invites",
            in_projects: "In projects",
            in_organizations: "In organizations",
            cancel: "Cancel",
            errorCancelInvites: "Failed to cancel invitation, please try again later!",
            inviteNewUser: "Invite new user"
        },
        _organizations: {
            organization: "Organization",
            organizations: "Organizations",
        },
        _projects: {
            personal: "Personal",
            shared: "Shared",
        },
        _calc: {
            lastCalculation: "Last calculation",
        },
        _charts: {
            toggleLegend: "Toggle legend",
            showV0: "Show zero sequence",
            hideV0: "Hide zero sequence",
        },
        _resetPassword: {
            passwordChanged: "Your password has been successfully changed!",
        },
        returnTo: "You can now return to the",
        toLoginPage: "login page",
        goBack: "Go back",
        ago: "ago",
        updated: "Updated",
        main: "Main",
        projects: "Projects",
        docs: "Docs",
        team: "Team",
        users: "Users",
        income: "Income",
        outcome: "Outcome",
        save: "Save",
        create: "Create",
        settings: "Settings",
        description: "Description",
        sentInvites: "Sent invites",
        nodes: "Nodes",
        node: "Node",
        equipments: "Equipments",
        branches: "Branches",
        mutualInductions: "Mutual inductions",
        calculations: "Calculations",
        name: "Name",
        nameLong: "Element Name",
        accountName: "Account name",
        tableRowLimit: "Limit of rows",
        _tablesNodes:
        {
            nom: "nom",
            voltageClass: "Voltage class, kV",
            load: "load",
            activePowerLoad: "Active load power, MW",
            reactivePowerLoad: "Reactive load power, Mvar",
            externalGrid: "External Grid",
        },
        _tablesBranchesEquip:
        {
            r12Long: "Active resistance of positive and negative sequence, Om",
            x12Long: "Reactive resistance of positive and negative sequence, Om",
            g12Long: "Active conductivity to ground of positive and negative sequence, μS",
            b12Long: "Reactive conductivity to ground of positive and negative sequence, μS",
            r1Long: "Positive sequence active resistance, Om",
            x1Long: "Positive sequence reactive resistance, Om",
            g1Long: "Positive sequence ground active admittance, μS",
            b1Long: "Positive sequence ground reactive conductance, μS",
            r2Long: "Negative sequence active resistance, Om",
            x2Long: "Negative sequence reactive resistance, Om",
            g2Long: "Negative sequence ground active admittance, μS",
            b2Long: "Negative sequence ground reactive conductance, μS",
            r0Long: "Zero sequence active resistance, Om",
            x0Long: "Zero sequence reactive resistance, Om",
            g0Long: "Negative sequence ground active admittance, μS",
            b0Long: "Zero sequence ground reactive conductance, μS",            
            EMFModuleLong: "Module of positive sequence generator EMF, kV",
            EMFAngleLong: "Angle of positive sequence generator EMF, deg.",
            startNode: "Start bus",
            startNodeLong: "Start bus: name",
            endNode: "End bus",            
            endNodeLong: "End bus: name",
            EMF: "EMF",
            angle: "angle",
            mod: "module",
            node: "Node",
            nodeLong:"The node to which the element is connected",
            startNodeGrounding: "Start node grounding",
            startNodeGroundingLong: "Start node grounding",
            endNodeGrounding: "End node grounding",            
            endNodeGroundingLong: "End node grounding",
            startNodenominalVoltage: "Vnom start bus",
            startNodenominalVoltageLong: "Voltages of the starting node for calculation of the transformation ratio, kV. The resistances are reduced to the voltage of the starting node.",
            endNodenominalVoltage: "Vnom end bus",
            endNodenominalVoltageLong: "Voltages of the ending node for calculation of the transformation ratio, kV. The resistances are reduced to the voltage of the starting node.",
            transformerAngle: "Transf. angle",                     
            transformerAngleLong: "Angle of the transformer winding connection group. If unknown, set to zero.",
        },
        _active:
        {
            isActiveLong: "The on state of an element in the equivalent circuit of all sequences",
            isActive: "Is Active",
            isActive0Long: "On state of an element in a zero-sequence equivalent circuit",
            isActive0: "Is Active 0",
        },
        _profile: {
            profilePageHeader: "Profile",
            profileLink: "Your profile",
            deleteProfile: "Delete profile",
            deleteDialogText: "Account deletion cannot be canceled. You will lose all data beyond recovery! Delete it anyway?",
            successAccountDeletedMsg: "Your account has been deleted.",
            loginIsTaken: "Login is already taken",
        },
        filter: "Filter",
        actions: "Actions",
        addRecord: "Add record",
        delete: "Delete",
        duplicate: "Duplicate",
        logout: "Logout",
        signIn: "Sign in",
        signUp: "Sign up",
        newPassword: "New password",
        continue: "Continue",
        forgotPassword: "Forgot password",
        password: "Password",
        repeatPassword: "Repeat password",
        alreadyHaveAccountSignIn: "Already have an account? Sign in",
        accept: "Accept",
        reject: "Reject",

        calculate: "Calculate",
        shortCircuitType: "Short-circuit type",
        damageLocation: "Location of damage",
        damageParams: "Damage parameters",
        measurementPlace: "Measurement place",

        // Колонки таблиц
        zeroSequenceParameters: "Zero sequence parameters",
        nonZeroSequenceParameters: "Non-zero sequence parameters",
        transformation_ratio: "Transformation ratio",  // Коэффициент трансформации

        grounding: "Zero sequence grounding",
        nominalVoltage: "Nominal voltage",

        // Единицы измеренний
        _measUnit:
        {
            kV: "kV",
            kA: "kA",
            grad: "deg.",
            MVA: "MVA",
            Om: "Om",
            Mvar: "Mvar",
            MW: "MW",
            mkSm: "μS",
        },

        // Типы КЗ
        _typeDamage:
        {
            K1Long: "SC 1 - Single-phase",
            K11Long: "SC 11 - Two-phase to ground",
            K2Long: "SC 2 - Two-phase",
            K3Long: "SC 3 - Three-phase",
        },
        // Типы групп расчетных параметров
        vectorTypeEnum:
        {
            phase: "Phase",
            linear: "Linear",
            sequence: "Sequences",
            sequencePhase: "Sequences, phase",
        },

        paramType:{
            currents: "Currents",
            voltages: "Voltages",
            resistances: "Resistances",
            powers: "Powers",
        },
        roleEnum: {
            owner: "Owner",
            admin: "Admin",
            member: "Member",
        },
        grounded: "Grounded",
        not_grounded: "Not grounded",
        disabled: "Disabled",

        dropUnattachedRows: "Delete unrelated rows",

        contact: "Contact",
        termsOfService: "Terms of service",
        aboutUs: "About us",
        createProject: "New project",
        newProject: "New project",

        createdAt: "Created at",
        createFromTestBus: "Create from test bus",

        // Отказ от ответственности
        _termsOfServicePage: {
            disclaimerOfWarranty: "Disclaimer of Warranty.",
            sentence1: "This product is provided \"as is\" without warranties of any kind, either express or implied.",
            sentence2: "makes no representations or warranties regarding the performance, reliability, or functionality of the product.",
            sentence3: "None of the authors, contributors, sponsors, administrators, operators, or anyone else associated with this resource is responsible for the appearance of inaccurate or false information, or for your use of the data contained in or linked from these web pages.",
        },        
        generalSet: "General settings",
        people: "People",
        dangerZone: "Danger Zone",
        noUsersFound: "No users found",
        _electricElements: {
            inductor: "Inductor",
            capacity: "Capacity",
            resistor: "Resistor",
        },
    },
};
